export default __webpack_public_path__ + "static/Pattern1-488658873c46110299cdba549e2cb29a.png";